import type { NeedAddTrialActionType } from '@telecom/shared/domain/permission';

/** 新用户赋权阶段可能返回的产品准入动作。 */
export type NewUserAccessAction = NeedAddTrialActionType | string | undefined;

/** 统一编排新用户产品准入、积分领取和首次引导释放。 */
export interface NewUserInitializationService {
    /**
     * 在应用挂载前幂等执行产品准入检查。
     * @returns 后端返回的产品准入动作。
     */
    prepareAccess(): Promise<NewUserAccessAction>;
    /** 在应用挂载后幂等执行积分检查，并在成功 Toast 退场后释放首次引导。 */
    completeAfterAppMount(): Promise<void>;
    /**
     * 等待当前页面的新用户初始化结束。
     * @returns 当前页面是否可以继续判断首次入口引导资格。
     */
    waitForEntryOnboarding(): Promise<boolean>;
    /** 返回产品准入检查当前是否仍在执行。 */
    isPreparingAccess(): boolean;
}

/** 新用户初始化编排服务的容器标识。 */
export const NewUserInitializationService = Symbol('NewUserInitializationService');
